export default __webpack_public_path__ + "static/media/angela4.00ed34e1.png";